import { render, staticRenderFns } from "./correctionCustom.vue?vue&type=template&id=2a59a39f&scoped=true&"
import script from "./correctionCustom.vue?vue&type=script&lang=js&"
export * from "./correctionCustom.vue?vue&type=script&lang=js&"
import style0 from "./correctionCustom.vue?vue&type=style&index=0&id=2a59a39f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a59a39f",
  null
  
)

export default component.exports